import actionTypes from "consts/actionTypes";

import { storeWeCareID } from "actions/session";

export function cleanAppointments() {
  return {
    type: actionTypes.CLEAN_APPOINTMENTS,
  };
}

export function getAppointments(weCareID) {
  return (dispatch) => {
    return new Promise((resolve) => {
      dispatch({
        request: {
          method: "GET",
          url: `/mobistar/calendar/appointment/public/${weCareID}/informat/json`,
        },
        onStart: () => {
          return {
            type: actionTypes.GET_APPOINTMENTS_PENDING,
          };
        },
        onSuccess: (payload, meta, dispatch) => {
          dispatch(storeWeCareID(weCareID));
          dispatch({
            type: actionTypes.GET_APPOINTMENTS_SUCCESS,
            payload,
          });
          resolve(payload);
        },
        onError: (payload) => {
          // Do something if the httpCode if >= 300
          resolve();
          return {
            type: actionTypes.GET_APPOINTMENTS_ERROR,
            error: payload.error,
          };
        },
      });
    });
  };
}

export function getNextAppointments(weCareID, appointmentId) {
  return (dispatch) => {
    return new Promise((resolve) => {
      dispatch({
        request: {
          method: "POST",
          url: `/mobistar/calendar/appointment/public/next/${weCareID}/informat/json`,
          body: JSON.stringify({
            appointmentId: appointmentId,
          }),
        },
        onStart: () => {
          return {
            type: actionTypes.GET_NEXT_APPOINTMENTS_PENDING,
          };
        },
        onSuccess: (payload, meta, dispatch) => {
          dispatch({
            type: actionTypes.GET_NEXT_APPOINTMENTS_SUCCESS,
            payload,
          });
          resolve(payload);
        },
        onError: (payload) => {
          // Do something if the httpCode if >= 300
          resolve();
          return {
            type: actionTypes.GET_NEXT_APPOINTMENTS_ERROR,
            error: payload.error,
          };
        },
      });
    });
  };
}

export function updateAppointment(weCareID, appointmentId, requestedDate, period) {
  return (dispatch) => {
    return new Promise((resolve) => {
      dispatch({
        request: {
          method: "POST",
          url: `/mobistar/calendar/appointment/public/update/${weCareID}/informat/json`,
          body: JSON.stringify({
            weCareID,
            appointmentId,
            requestedDate,
            period,
          }),
        },
        onStart: () => {
          return {
            type: actionTypes.POST_UPDATE_APPOINTMENTS_PENDING,
          };
        },
        onSuccess: (payload, meta, dispatch) => {
          dispatch({
            type: actionTypes.POST_UPDATE_APPOINTMENTS_SUCCESS,
            payload,
          });
          resolve(payload);
        },
        onError: (payload) => {
          // Do something if the httpCode if >= 300
          resolve();
          return {
            type: actionTypes.POST_UPDATE_APPOINTMENTS_ERROR,
            error: payload.error,
          };
        },
      });
    });
  };
}



// WEBPACK FOOTER //
// ./src/actions/appointments.js